<div class="modal-header justify-content-between">
  <div>
    <h4>Time Off Request</h4>
    <small class="ms-2"
      >{{ existingModel.EditedRecord.DateApproved | date: 'MM/dd/YY' }}
      <span *ngIf="!isEmployeePortal">- {{ existingModel.EditedRecord.PersonName }}</span>
    </small>
  </div>
  <div>
    <span class="badge bg-warning">Pending Change</span>
    <button type="button" class="close ms-3" aria-label="Close" (click)="closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</div>
<div class="modal-body" *ngIf="existingModel != null">
  <div class="row">
    <div class="col-7">
      <div class="row mb-3">
        <div class="col-12">
          <span>Time Off Type: </span>
          <ng-container *ngFor="let plan of timeOffPlans">
            <span *ngIf="plan.Id == existingModel.EditedRecord.PlanId">{{ plan.Name }}</span>
          </ng-container>
        </div>
      </div>
      <div class="row mb-3">
        <div class="d-flex justify-content-start">
          <span class="pe-3">Request Type: </span>
          <div class="d-flex flex-column justify-content-start">
            <div>
              <span *ngIf="existingModel.EditedRecord.RequestType == RequestTypes.PartialDay"
                >Partial Day</span
              >
              <span *ngIf="existingModel.EditedRecord.RequestType == RequestTypes.SingleDay"
                >Single Day</span
              >
              <span *ngIf="existingModel.EditedRecord.RequestType == RequestTypes.MultipleDays"
                >Multiple Days</span
              >
            </div>
            <div
              *ngIf="
                existingModel.OriginalRecord != null &&
                existingModel.EditedRecord.RequestType != existingModel.OriginalRecord.RequestType
              ">
              <span
                class="text-danger"
                *ngIf="existingModel.OriginalRecord.RequestType == RequestTypes.PartialDay"
                ><s>Partial Day</s></span
              >
              <span
                class="text-danger"
                *ngIf="existingModel.OriginalRecord.RequestType == RequestTypes.SingleDay"
                ><s>Single Day</s></span
              >
              <span
                class="text-danger"
                *ngIf="existingModel.OriginalRecord.RequestType == RequestTypes.MultipleDays"
                ><s>Multiple Days</s></span
              >
            </div>
          </div>
        </div>
      </div>
      <ng-container *ngIf="existingModel.EditedRecord.RequestType == RequestTypes.SingleDay">
        <div class="row mb-3">
          <div class="col-12">
            <div class="d-flex justify-content-start">
              <span class="pe-3">Date: </span>
              <div class="d-flex flex-column justify-content-start">
                <span>{{ existingModel.EditedRecord.StartDate | date: 'MM/dd/YY' }}</span>
                <span
                  *ngIf="
                    existingModel.OriginalRecord != null &&
                    !AreDatesEqual(
                      existingModel.EditedRecord.StartDate,
                      existingModel.OriginalRecord.StartDate
                    )
                  ">
                  <s class="text-danger">{{
                    existingModel.OriginalRecord.StartDate | date: 'MM/dd/YY'
                  }}</s>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-12">
            <div class="d-flex justify-content-start">
              <span class="pe-3">Hours: </span>
              <div class="d-flex flex-column justify-content-start">
                <span>{{ currentRequestHours }}</span>
                <span
                  *ngIf="
                    existingModel.OriginalRecord != null &&
                    currentRequestHours != previousRequestHours
                  ">
                  <s class="text-danger">{{ previousRequestHours }}</s>
                </span>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="existingModel.EditedRecord.RequestType == RequestTypes.PartialDay">
        <div class="row mb-3">
          <div class="col-12">
            <div class="d-flex justify-content-start">
              <span class="pe-3">Date: </span>
              <div class="d-flex flex-column justify-content-start">
                <span>{{ existingModel.EditedRecord.StartDate | date: 'MM/dd/YY' }}</span>
                <span
                  *ngIf="
                    existingModel.OriginalRecord != null &&
                    !AreDatesEqual(
                      existingModel.EditedRecord.StartDate,
                      existingModel.OriginalRecord.StartDate
                    )
                  ">
                  <s class="text-danger">{{
                    existingModel.OriginalRecord.StartDate | date: 'MM/dd/YY'
                  }}</s>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-6">
            <div class="d-flex justify-content-between">
              <span>Start Time: </span>
              <div class="d-flex flex-column justify-content-start">
                <span>{{ existingModel.EditedRecord.StartDate | date: 'shortTime' }}</span>
                <span
                  *ngIf="
                    existingModel.OriginalRecord != null &&
                    existingModel.OriginalRecord.RequestType == RequestTypes.PartialDay &&
                    !startTimesEqual
                  "
                  ><s class="text-danger">{{
                    existingModel.OriginalRecord.StartDate | date: 'shortTime'
                  }}</s></span
                >
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="d-flex justify-content-between">
              <span>End Time: </span>
              <div class="d-flex flex-column justify-content-start">
                <span>{{ existingModel.EditedRecord.EndDate | date: 'shortTime' }}</span>
                <span
                  *ngIf="
                    existingModel.OriginalRecord != null &&
                    existingModel.OriginalRecord.RequestType == RequestTypes.PartialDay &&
                    !endTimesEqual
                  "
                  ><s class="text-danger">{{
                    existingModel.OriginalRecord.EndDate | date: 'shortTime'
                  }}</s></span
                >
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-12">
            <div class="d-flex justify-content-start">
              <span class="pe-3">Hours: </span>
              <div class="d-flex flex-column justify-content-start">
                <span *ngIf="existingModel.EditedRecord.RequestType == RequestTypes.PartialDay">{{
                  partialDayHours | async | number: '1.2'
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="existingModel.EditedRecord.RequestType == RequestTypes.MultipleDays">
        <div class="row mb-3">
          <div class="col-6">
            <div class="d-flex justify-content-between">
              <span>Start: </span>
              <div class="d-flex flex-column justify-content-start">
                <span>{{ existingModel.EditedRecord.StartDate | date: 'MM/dd/YY' }}</span>
                <span
                  *ngIf="
                    existingModel.OriginalRecord != null &&
                    existingModel.EditedRecord.StartDate != existingModel.OriginalRecord.StartDate
                  ">
                  <s class="text-danger">{{
                    existingModel.OriginalRecord.StartDate | date: 'MM/dd/YY'
                  }}</s>
                </span>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="d-flex justify-content-between">
              <span>End: </span>
              <div class="d-flex flex-column justify-content-start">
                <span>{{ existingModel.EditedRecord.EndDate | date: 'MM/dd/YY' }}</span>
                <span
                  *ngIf="
                    existingModel.OriginalRecord != null &&
                    existingModel.OriginalRecord.RequestType == RequestTypes.MultipleDays &&
                    existingModel.EditedRecord.EndDate != existingModel.OriginalRecord.EndDate
                  ">
                  <s class="text-danger">
                    {{ existingModel.OriginalRecord.EndDate | date: 'MM/dd/YY' }}
                  </s>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-12">
            <div class="d-flex justify-content-start">
              <span class="pe-3">Hours Per Day: </span>
              <div class="d-flex flex-column justify-content-start">
                <span>{{ existingModel.EditedRecord.TimeOffDays[0].Hours | number: '1.2' }}</span>
                <span
                  *ngIf="
                    existingModel.OriginalRecord != null &&
                    existingModel.EditedRecord.TimeOffDays[0].Hours !=
                      existingModel.OriginalRecord.TimeOffDays[0].Hours
                  ">
                  <s class="text-danger">{{
                    existingModel.OriginalRecord.TimeOffDays[0].Hours | number: '1.2'
                  }}</s>
                </span>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
    <div class="col-5">
      <lib-hours-display
        [editedRequest]="existingModel"
        [personId]="existingModel.EditedRecord.PersonId"
        [planId]="currentPlanObs"></lib-hours-display>
    </div>
  </div>
  <div class="row mt-1">
    <div class="col-12">
      <label>Employer Comments:</label>
      <p>{{ existingModel.ClientComments }}</p>
    </div>
  </div>
  <div class="row mt-1">
    <span *ngIf="isWeekend()" class="text-danger">Your selected days include weekends.</span>
    <span *ngIf="showHolidayMessage" class="text-danger">Your selected days include holidays.</span>
  </div>
</div>
<div class="modal-footer text-right" *ngIf="existingModel != null && isEmployeePortal">
  <button class="btn btn-secondary" (click)="cancelRequest()">Cancel Request</button>
  <button class="btn btn-primary ms-3" (click)="acceptRequest()">Accept</button>
</div>
